<template>
  <div>
    <el-upload action="" :disabled="!!value || (percentage === 0 ? false : true)" :http-request="httpRequest"
      :style="{ height: height, width: width }" class="upload-cover" :show-file-list="false">
      <div slot="trigger" style="width: 100%;height: 100%;">
        <div class="f-c-c" style="height: 100%;width: 100%;" v-if="!value">
          <div v-if="percentage === 0" style="font-size: 28px;color: #8c939d;text-align: center;">
            <i class="el-icon-camera"></i>
            <div style="font-size: 14px;color: #919ead;">上传图片</div>
          </div>
          <div v-else style="width: 100%;padding: 10px;text-align: center;">
            <el-progress :type="progressType" :percentage="percentage" :width="progressWidth"
              :text-inside="progressType == 'circle' ? false : true"
              :stroke-width="progressType == 'circle' ? 6 : 18" />
          </div>
        </div>
        <div v-else class="has-img f-c-c" style="height: 100%;width: 100%;position: relative;">
          <el-image :src="value" :style="imageStyle" fit="cover" />
          <div class="mask f-c-c">
            <div style="cursor: pointer;" @click.stop="showImageViewer = true">
              <i class="el-icon-zoom-in"></i>
            </div>
            <div style="cursor: pointer; margin-left: 16px;" @click.stop="handleDelete">
              <i class="el-icon-delete"></i>
            </div>
          </div>
        </div>
      </div>
    </el-upload>

    <!-- 图片预览对话框 -->
    <el-dialog title="图片预览" :visible.sync="showImageViewer" width="80%" center :before-close="handleClosePreview"
      append-to-body>
      <div class="image-preview-container">
        <img :src="value" alt="预览图片" class="preview-image" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { uploadfile } from '@/api'
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    height: {
      type: String,
      default: "100px",
    },
    width: {
      type: String,
      default: "100px",
    },
    progressWidth: {
      type: Number,
      default: 100,
    },
    progressType: {
      type: String,
      default: "circle",
    },
    imageStyle: {
      type: String,
      default: "width:100%;height:100%;",
    }
  },
  data() {
    return {
      percentage: 0,
      showImageViewer: false,
    };
  },
  created() {

  },
  methods: {
    async httpRequest(options) {
      try {
        let formData = new FormData()
        formData.append("file", options.file)
        const url = await uploadfile(formData)
        this.$emit('input', url)
        this.percentage = 0
      } catch (error) {
        this.percentage = 0
      }
    },
    onUploadProgress(progress) {
      this.percentage = +(progress.progress * 100 - 1).toFixed(0)
    },
    handleDelete() {
      this.$emit('input', '')
    },
    handleClosePreview() {
      this.showImageViewer = false
    }
  },
};
</script>

<style>
.upload-cover>.el-upload--text {
  display: flex !important;
  height: 100% !important;
}
</style>
<style scoped>
.f-c-c {
  display: flex;
  justify-content: center;
  align-items: center;
}

.upload-cover {
  background-color: rgb(145, 158, 171, 0.08);
  border-radius: 6px;
  overflow: hidden;
  box-sizing: border-box;
}

.mask {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0;
  transition: opacity .3s;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  font-size: 20px;
  cursor: default;
}

.has-img:hover .mask {
  opacity: 1;
}

/* 图片预览样式 */
.image-preview-container {
  text-align: center;
  padding: 20px;
}

.preview-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style>